import type { FC } from "react";

import { Skeleton, Spacer } from "@aviary";
import { SignInWrapper } from "@unauthenticated/shared/components";
import {
  SignInLayout,
  SkeletonForgotPasswordForm,
  SkeletonReturnToSignInButton,
} from "@unauthenticated/signupSignin/components";

const SkeletonForgotPasswordPage: FC = () => {
  return (
    <SignInLayout>
      <SignInWrapper>
        <Skeleton type="typography" typographySize="h1" margin="bottom" />
        <Spacer height="half" />
        <Skeleton type="typography" typographySize="body" isFullwidth margin="topAndBottom" />
        <Spacer height="half" />
        <Skeleton type="typography" typographySize="body" />
        <SkeletonForgotPasswordForm />
        <SkeletonReturnToSignInButton />
      </SignInWrapper>
    </SignInLayout>
  );
};

export { SkeletonForgotPasswordPage };
